





































import { defineComponent, PropType, useFetch, ref } from '@nuxtjs/composition-api';
import { has, sortBy } from 'lodash-es';
import { v4 as uuidv4 } from 'uuid';
import AppIcon from '~/components/partials/App/AppIcon.vue';
import AppLink from '~/components/partials/App/AppLink.vue';
import { useStore } from '~/composables/useStore';
import { SALES_LOCATION_DISPLAY_ORDER } from '~/constants/shop';
import { url } from '~/utils';
import { ECSchema } from '~/types/api';
import { HostShop, HostShopList } from '~/types/modules/contents';

export default defineComponent({
  components: {
    AppIcon,
    AppLink,
  },
  props: {
    item: {
      type: Object as PropType<HostShop>,
      required: true,
    },
  },
  setup(props) {
    const store = useStore();
    const hostSalesLocations = ref<Record<string, ECSchema<'saleslocation.SalesLocation'>[]>>({});
    const shopList = ref<Array<HostShopList>>([]);
    const uuid = uuidv4();

    useFetch(async () => {
      if (props.item.host_shop_ids.length === 0) return;

      const { data } = await store.dispatch('modules/salesLocation/fetchAllSalesLocations', {
        query: {
          ids: props.item.host_shop_ids.join(','),
          limit: 2000,
          page: 1,
        },
      });
      if (!data) return;

      // 子エリアをkeyとしたRecord型に整形する
      data.forEach((shop: ECSchema<'saleslocation.SalesLocation'>) => {
        if (!shop.area_id) return;
        const areaId = shop.area_id.toString();
        if (!has(hostSalesLocations.value, areaId)) {
          hostSalesLocations.value[areaId] = [];
        }
        hostSalesLocations.value[areaId].push(shop);
      });

      // Record型のオブジェクトを配列に均した後に、エリアIDをキー、紐づく店舗一覧情報をバリューとするオブジェクトの配列に変換
      shopList.value = Object.entries(hostSalesLocations.value)
        .map(([areaId, shopList]) => ({ areaId, shopList }))
        .sort((a, b) => {
          const orderA = a.shopList[0].area_display_order || 0;
          const orderB = b.shopList[0].area_display_order || 0;
          // 表示順が小さいものを前に持ってくる（差分が正の数であれば入れ替える）
          return orderA - orderB;
        });
    });

    /** 拠点マスタの表示順でソートする */
    const sortBySalesLocationDisplayOrder = (shopList: ECSchema<'saleslocation.SalesLocation'>[]) => {
      return sortBy(shopList, SALES_LOCATION_DISPLAY_ORDER);
    };

    /** エリアIDからエリア名に変換 */
    const formatAreaName = (id: string): string => {
      // Record型のオブジェクトを配列にならす
      const salesLocation = Object.entries(hostSalesLocations.value).find((pair) => {
        const currentSalesLocation = hostSalesLocations.value[pair[0]][0];
        // 選択したIDと同じ親エリアIDを持つオブジェクトがあれば返す
        return currentSalesLocation.area_id?.toString() === id;
      });
      if (salesLocation) {
        // エリア名であるkeyを文字列で返す
        return salesLocation[1][0].area_name || '';
      }
      return '';
    };

    return { sortBySalesLocationDisplayOrder, formatAreaName, url, shopList, hostSalesLocations, uuid };
  },
});
